module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[112]599.41ebba9.woff2";